import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { useMaintenanceModel } from "../maintenanceModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useMaintenanceModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "客户名称",
            placeholder: Locale["Customer"],
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "联系人",
            placeholder: Locale["Contact"],
            fieldName: "contact",
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "单据状态",
            placeholder: Locale["Status"],
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.MAINTENANCE)
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "单据编号",
            placeholder: Locale["AppointmentDocNo"],
            fieldName: "maintenanceCode"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "维修类型",
            placeholder: Locale["Service Type"],
            fieldName: "serviceTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE)
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "车牌号",
            placeholder: Locale["License Plate"],
            fieldName: "licensePlate"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "VIN码",
            placeholder: Locale["VIN"],
            fieldName: "vin"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "支付状态",
            placeholder: Locale["Payment status"],
            fieldName: "payStatus",
            options: getSelectedDictOne(DictCodeEnmu.PAY_STATUS1)
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            // placeholder: ["制单日期起始", "制单日期结束"],
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        }
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["CreateBusinessDocs"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Maintenance"]}
        </span>
    </>
    return (
        <>
            <YhPageHeader
                title={PageHeaderTitle}
                size="small"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={loadData}
                handleReset={resetSearchParam}
            />
        </>
    );
}